// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: stcs_comp_acc_data.entity.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import {
  AccNumberSchemaEnum,
  accNumberSchemaEnumFromJSON,
  accNumberSchemaEnumToJSON,
  ExcelFileSchemaEnum,
  excelFileSchemaEnumFromJSON,
  excelFileSchemaEnumToJSON,
  StcsPubSubStatusEnum,
  stcsPubSubStatusEnumFromJSON,
  stcsPubSubStatusEnumToJSON,
} from "./stcs_enums.entity";

export const protobufPackage = "stcs_cmw";

export interface StcsCompAccData {
  id: string;
  version: string;
  meta: StcsCompAccDataMetaData | undefined;
  status: StcsPubSubStatusEnum;
  acc_data_content_file_list: StcsCompAccDataContent[];
  acc_name_map: { [key: string]: string };
  acc_data_values: StcsCompAccDataValues | undefined;
}

export interface StcsCompAccData_AccNameMapEntry {
  key: string;
  value: string;
}

export interface StcsCompAccDataContent {
  file_name: string;
  s3_path: string;
}

export interface StcsCompAccDataMetaData {
  ref_id_user: string;
  ref_id_org: string;
  ref_id_comp: string;
  ref_id_comp_acc_mapping: string;
  obj_created_iso_utc: string;
  obj_updated_iso_utc: string;
  numb_of_accounts: number;
  std_acc_schema_score: number;
  acc_number_schema: AccNumberSchemaEnum;
  excel_file_schema: ExcelFileSchemaEnum;
  fpna_date_string_begin: string;
  fpna_date_string_end: string;
  acc_changes_in_value_map: { [key: string]: StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap };
}

export interface StcsCompAccDataMetaData_AccChangesInValueMapEntry {
  key: string;
  value: StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap | undefined;
}

export interface StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap {
  /** List of accounts that have changed in value */
  acc_list: StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap_StcsCompAccDataMetaDataAccIdMapItem[];
}

export interface StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap_StcsCompAccDataMetaDataAccIdMapItem {
  acc_id: string;
  acc_name: string;
}

export interface StcsCompAccDataValues {
  /** Key(AccNumber), Value(StcsCompAccDataValuesMap) */
  pnl_map: { [key: string]: StcsCompAccDataValuesMap };
  bs_map: { [key: string]: StcsCompAccDataValuesMap };
}

export interface StcsCompAccDataValues_PnlMapEntry {
  key: string;
  value: StcsCompAccDataValuesMap | undefined;
}

export interface StcsCompAccDataValues_BsMapEntry {
  key: string;
  value: StcsCompAccDataValuesMap | undefined;
}

export interface StcsCompAccDataValuesMap {
  /** Key(YYYY-MM), Value(Account Value) */
  values_map: { [key: string]: number };
}

export interface StcsCompAccDataValuesMap_ValuesMapEntry {
  key: string;
  value: number;
}

function createBaseStcsCompAccData(): StcsCompAccData {
  return {
    id: "",
    version: "",
    meta: undefined,
    status: 0,
    acc_data_content_file_list: [],
    acc_name_map: {},
    acc_data_values: undefined,
  };
}

export const StcsCompAccData: MessageFns<StcsCompAccData> = {
  encode(message: StcsCompAccData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.version !== "") {
      writer.uint32(18).string(message.version);
    }
    if (message.meta !== undefined) {
      StcsCompAccDataMetaData.encode(message.meta, writer.uint32(26).fork()).join();
    }
    if (message.status !== 0) {
      writer.uint32(40).int32(message.status);
    }
    for (const v of message.acc_data_content_file_list) {
      StcsCompAccDataContent.encode(v!, writer.uint32(50).fork()).join();
    }
    Object.entries(message.acc_name_map).forEach(([key, value]) => {
      StcsCompAccData_AccNameMapEntry.encode({ key: key as any, value }, writer.uint32(58).fork()).join();
    });
    if (message.acc_data_values !== undefined) {
      StcsCompAccDataValues.encode(message.acc_data_values, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompAccData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompAccData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.version = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.meta = StcsCompAccDataMetaData.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.acc_data_content_file_list.push(StcsCompAccDataContent.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          const entry7 = StcsCompAccData_AccNameMapEntry.decode(reader, reader.uint32());
          if (entry7.value !== undefined) {
            message.acc_name_map[entry7.key] = entry7.value;
          }
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.acc_data_values = StcsCompAccDataValues.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompAccData {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      version: isSet(object.version) ? globalThis.String(object.version) : "",
      meta: isSet(object.meta) ? StcsCompAccDataMetaData.fromJSON(object.meta) : undefined,
      status: isSet(object.status) ? stcsPubSubStatusEnumFromJSON(object.status) : 0,
      acc_data_content_file_list: globalThis.Array.isArray(object?.acc_data_content_file_list)
        ? object.acc_data_content_file_list.map((e: any) => StcsCompAccDataContent.fromJSON(e))
        : [],
      acc_name_map: isObject(object.acc_name_map)
        ? Object.entries(object.acc_name_map).reduce<{ [key: string]: string }>((acc, [key, value]) => {
          acc[key] = String(value);
          return acc;
        }, {})
        : {},
      acc_data_values: isSet(object.acc_data_values)
        ? StcsCompAccDataValues.fromJSON(object.acc_data_values)
        : undefined,
    };
  },

  toJSON(message: StcsCompAccData): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.version !== "") {
      obj.version = message.version;
    }
    if (message.meta !== undefined) {
      obj.meta = StcsCompAccDataMetaData.toJSON(message.meta);
    }
    if (message.status !== 0) {
      obj.status = stcsPubSubStatusEnumToJSON(message.status);
    }
    if (message.acc_data_content_file_list?.length) {
      obj.acc_data_content_file_list = message.acc_data_content_file_list.map((e) => StcsCompAccDataContent.toJSON(e));
    }
    if (message.acc_name_map) {
      const entries = Object.entries(message.acc_name_map);
      if (entries.length > 0) {
        obj.acc_name_map = {};
        entries.forEach(([k, v]) => {
          obj.acc_name_map[k] = v;
        });
      }
    }
    if (message.acc_data_values !== undefined) {
      obj.acc_data_values = StcsCompAccDataValues.toJSON(message.acc_data_values);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompAccData>, I>>(base?: I): StcsCompAccData {
    return StcsCompAccData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompAccData>, I>>(object: I): StcsCompAccData {
    const message = createBaseStcsCompAccData();
    message.id = object.id ?? "";
    message.version = object.version ?? "";
    message.meta = (object.meta !== undefined && object.meta !== null)
      ? StcsCompAccDataMetaData.fromPartial(object.meta)
      : undefined;
    message.status = object.status ?? 0;
    message.acc_data_content_file_list =
      object.acc_data_content_file_list?.map((e) => StcsCompAccDataContent.fromPartial(e)) || [];
    message.acc_name_map = Object.entries(object.acc_name_map ?? {}).reduce<{ [key: string]: string }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value);
        }
        return acc;
      },
      {},
    );
    message.acc_data_values = (object.acc_data_values !== undefined && object.acc_data_values !== null)
      ? StcsCompAccDataValues.fromPartial(object.acc_data_values)
      : undefined;
    return message;
  },
};

function createBaseStcsCompAccData_AccNameMapEntry(): StcsCompAccData_AccNameMapEntry {
  return { key: "", value: "" };
}

export const StcsCompAccData_AccNameMapEntry: MessageFns<StcsCompAccData_AccNameMapEntry> = {
  encode(message: StcsCompAccData_AccNameMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompAccData_AccNameMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompAccData_AccNameMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompAccData_AccNameMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: StcsCompAccData_AccNameMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompAccData_AccNameMapEntry>, I>>(base?: I): StcsCompAccData_AccNameMapEntry {
    return StcsCompAccData_AccNameMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompAccData_AccNameMapEntry>, I>>(
    object: I,
  ): StcsCompAccData_AccNameMapEntry {
    const message = createBaseStcsCompAccData_AccNameMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseStcsCompAccDataContent(): StcsCompAccDataContent {
  return { file_name: "", s3_path: "" };
}

export const StcsCompAccDataContent: MessageFns<StcsCompAccDataContent> = {
  encode(message: StcsCompAccDataContent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.file_name !== "") {
      writer.uint32(26).string(message.file_name);
    }
    if (message.s3_path !== "") {
      writer.uint32(34).string(message.s3_path);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompAccDataContent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompAccDataContent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.file_name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.s3_path = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompAccDataContent {
    return {
      file_name: isSet(object.file_name) ? globalThis.String(object.file_name) : "",
      s3_path: isSet(object.s3_path) ? globalThis.String(object.s3_path) : "",
    };
  },

  toJSON(message: StcsCompAccDataContent): unknown {
    const obj: any = {};
    if (message.file_name !== "") {
      obj.file_name = message.file_name;
    }
    if (message.s3_path !== "") {
      obj.s3_path = message.s3_path;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompAccDataContent>, I>>(base?: I): StcsCompAccDataContent {
    return StcsCompAccDataContent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompAccDataContent>, I>>(object: I): StcsCompAccDataContent {
    const message = createBaseStcsCompAccDataContent();
    message.file_name = object.file_name ?? "";
    message.s3_path = object.s3_path ?? "";
    return message;
  },
};

function createBaseStcsCompAccDataMetaData(): StcsCompAccDataMetaData {
  return {
    ref_id_user: "",
    ref_id_org: "",
    ref_id_comp: "",
    ref_id_comp_acc_mapping: "",
    obj_created_iso_utc: "",
    obj_updated_iso_utc: "",
    numb_of_accounts: 0,
    std_acc_schema_score: 0,
    acc_number_schema: 0,
    excel_file_schema: 0,
    fpna_date_string_begin: "",
    fpna_date_string_end: "",
    acc_changes_in_value_map: {},
  };
}

export const StcsCompAccDataMetaData: MessageFns<StcsCompAccDataMetaData> = {
  encode(message: StcsCompAccDataMetaData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(26).string(message.ref_id_comp);
    }
    if (message.ref_id_comp_acc_mapping !== "") {
      writer.uint32(50).string(message.ref_id_comp_acc_mapping);
    }
    if (message.obj_created_iso_utc !== "") {
      writer.uint32(34).string(message.obj_created_iso_utc);
    }
    if (message.obj_updated_iso_utc !== "") {
      writer.uint32(42).string(message.obj_updated_iso_utc);
    }
    if (message.numb_of_accounts !== 0) {
      writer.uint32(64).uint32(message.numb_of_accounts);
    }
    if (message.std_acc_schema_score !== 0) {
      writer.uint32(73).double(message.std_acc_schema_score);
    }
    if (message.acc_number_schema !== 0) {
      writer.uint32(80).int32(message.acc_number_schema);
    }
    if (message.excel_file_schema !== 0) {
      writer.uint32(88).int32(message.excel_file_schema);
    }
    if (message.fpna_date_string_begin !== "") {
      writer.uint32(98).string(message.fpna_date_string_begin);
    }
    if (message.fpna_date_string_end !== "") {
      writer.uint32(106).string(message.fpna_date_string_end);
    }
    Object.entries(message.acc_changes_in_value_map).forEach(([key, value]) => {
      StcsCompAccDataMetaData_AccChangesInValueMapEntry.encode({ key: key as any, value }, writer.uint32(114).fork())
        .join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompAccDataMetaData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompAccDataMetaData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.ref_id_comp_acc_mapping = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.obj_created_iso_utc = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.obj_updated_iso_utc = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.numb_of_accounts = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 73) {
            break;
          }

          message.std_acc_schema_score = reader.double();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.acc_number_schema = reader.int32() as any;
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.excel_file_schema = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.fpna_date_string_begin = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.fpna_date_string_end = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          const entry14 = StcsCompAccDataMetaData_AccChangesInValueMapEntry.decode(reader, reader.uint32());
          if (entry14.value !== undefined) {
            message.acc_changes_in_value_map[entry14.key] = entry14.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompAccDataMetaData {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
      ref_id_comp_acc_mapping: isSet(object.ref_id_comp_acc_mapping)
        ? globalThis.String(object.ref_id_comp_acc_mapping)
        : "",
      obj_created_iso_utc: isSet(object.obj_created_iso_utc) ? globalThis.String(object.obj_created_iso_utc) : "",
      obj_updated_iso_utc: isSet(object.obj_updated_iso_utc) ? globalThis.String(object.obj_updated_iso_utc) : "",
      numb_of_accounts: isSet(object.numb_of_accounts) ? globalThis.Number(object.numb_of_accounts) : 0,
      std_acc_schema_score: isSet(object.std_acc_schema_score) ? globalThis.Number(object.std_acc_schema_score) : 0,
      acc_number_schema: isSet(object.acc_number_schema) ? accNumberSchemaEnumFromJSON(object.acc_number_schema) : 0,
      excel_file_schema: isSet(object.excel_file_schema) ? excelFileSchemaEnumFromJSON(object.excel_file_schema) : 0,
      fpna_date_string_begin: isSet(object.fpna_date_string_begin)
        ? globalThis.String(object.fpna_date_string_begin)
        : "",
      fpna_date_string_end: isSet(object.fpna_date_string_end) ? globalThis.String(object.fpna_date_string_end) : "",
      acc_changes_in_value_map: isObject(object.acc_changes_in_value_map)
        ? Object.entries(object.acc_changes_in_value_map).reduce<
          { [key: string]: StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap }
        >((acc, [key, value]) => {
          acc[key] = StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap.fromJSON(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: StcsCompAccDataMetaData): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    if (message.ref_id_comp_acc_mapping !== "") {
      obj.ref_id_comp_acc_mapping = message.ref_id_comp_acc_mapping;
    }
    if (message.obj_created_iso_utc !== "") {
      obj.obj_created_iso_utc = message.obj_created_iso_utc;
    }
    if (message.obj_updated_iso_utc !== "") {
      obj.obj_updated_iso_utc = message.obj_updated_iso_utc;
    }
    if (message.numb_of_accounts !== 0) {
      obj.numb_of_accounts = Math.round(message.numb_of_accounts);
    }
    if (message.std_acc_schema_score !== 0) {
      obj.std_acc_schema_score = message.std_acc_schema_score;
    }
    if (message.acc_number_schema !== 0) {
      obj.acc_number_schema = accNumberSchemaEnumToJSON(message.acc_number_schema);
    }
    if (message.excel_file_schema !== 0) {
      obj.excel_file_schema = excelFileSchemaEnumToJSON(message.excel_file_schema);
    }
    if (message.fpna_date_string_begin !== "") {
      obj.fpna_date_string_begin = message.fpna_date_string_begin;
    }
    if (message.fpna_date_string_end !== "") {
      obj.fpna_date_string_end = message.fpna_date_string_end;
    }
    if (message.acc_changes_in_value_map) {
      const entries = Object.entries(message.acc_changes_in_value_map);
      if (entries.length > 0) {
        obj.acc_changes_in_value_map = {};
        entries.forEach(([k, v]) => {
          obj.acc_changes_in_value_map[k] = StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompAccDataMetaData>, I>>(base?: I): StcsCompAccDataMetaData {
    return StcsCompAccDataMetaData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompAccDataMetaData>, I>>(object: I): StcsCompAccDataMetaData {
    const message = createBaseStcsCompAccDataMetaData();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    message.ref_id_comp_acc_mapping = object.ref_id_comp_acc_mapping ?? "";
    message.obj_created_iso_utc = object.obj_created_iso_utc ?? "";
    message.obj_updated_iso_utc = object.obj_updated_iso_utc ?? "";
    message.numb_of_accounts = object.numb_of_accounts ?? 0;
    message.std_acc_schema_score = object.std_acc_schema_score ?? 0;
    message.acc_number_schema = object.acc_number_schema ?? 0;
    message.excel_file_schema = object.excel_file_schema ?? 0;
    message.fpna_date_string_begin = object.fpna_date_string_begin ?? "";
    message.fpna_date_string_end = object.fpna_date_string_end ?? "";
    message.acc_changes_in_value_map = Object.entries(object.acc_changes_in_value_map ?? {}).reduce<
      { [key: string]: StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap }
    >((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap.fromPartial(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBaseStcsCompAccDataMetaData_AccChangesInValueMapEntry(): StcsCompAccDataMetaData_AccChangesInValueMapEntry {
  return { key: "", value: undefined };
}

export const StcsCompAccDataMetaData_AccChangesInValueMapEntry: MessageFns<
  StcsCompAccDataMetaData_AccChangesInValueMapEntry
> = {
  encode(
    message: StcsCompAccDataMetaData_AccChangesInValueMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompAccDataMetaData_AccChangesInValueMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompAccDataMetaData_AccChangesInValueMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompAccDataMetaData_AccChangesInValueMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value)
        ? StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap.fromJSON(object.value)
        : undefined,
    };
  },

  toJSON(message: StcsCompAccDataMetaData_AccChangesInValueMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompAccDataMetaData_AccChangesInValueMapEntry>, I>>(
    base?: I,
  ): StcsCompAccDataMetaData_AccChangesInValueMapEntry {
    return StcsCompAccDataMetaData_AccChangesInValueMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompAccDataMetaData_AccChangesInValueMapEntry>, I>>(
    object: I,
  ): StcsCompAccDataMetaData_AccChangesInValueMapEntry {
    const message = createBaseStcsCompAccDataMetaData_AccChangesInValueMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap(): StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap {
  return { acc_list: [] };
}

export const StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap: MessageFns<
  StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap
> = {
  encode(
    message: StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    for (const v of message.acc_list) {
      StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap_StcsCompAccDataMetaDataAccIdMapItem.encode(
        v!,
        writer.uint32(10).fork(),
      ).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.acc_list.push(
            StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap_StcsCompAccDataMetaDataAccIdMapItem.decode(
              reader,
              reader.uint32(),
            ),
          );
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap {
    return {
      acc_list: globalThis.Array.isArray(object?.acc_list)
        ? object.acc_list.map((e: any) =>
          StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap_StcsCompAccDataMetaDataAccIdMapItem.fromJSON(e)
        )
        : [],
    };
  },

  toJSON(message: StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap): unknown {
    const obj: any = {};
    if (message.acc_list?.length) {
      obj.acc_list = message.acc_list.map((e) =>
        StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap_StcsCompAccDataMetaDataAccIdMapItem.toJSON(e)
      );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap>, I>>(
    base?: I,
  ): StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap {
    return StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap>, I>>(
    object: I,
  ): StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap {
    const message = createBaseStcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap();
    message.acc_list =
      object.acc_list?.map((e) =>
        StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap_StcsCompAccDataMetaDataAccIdMapItem.fromPartial(e)
      ) || [];
    return message;
  },
};

function createBaseStcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap_StcsCompAccDataMetaDataAccIdMapItem(): StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap_StcsCompAccDataMetaDataAccIdMapItem {
  return { acc_id: "", acc_name: "" };
}

export const StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap_StcsCompAccDataMetaDataAccIdMapItem: MessageFns<
  StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap_StcsCompAccDataMetaDataAccIdMapItem
> = {
  encode(
    message: StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap_StcsCompAccDataMetaDataAccIdMapItem,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.acc_id !== "") {
      writer.uint32(10).string(message.acc_id);
    }
    if (message.acc_name !== "") {
      writer.uint32(18).string(message.acc_name);
    }
    return writer;
  },

  decode(
    input: BinaryReader | Uint8Array,
    length?: number,
  ): StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap_StcsCompAccDataMetaDataAccIdMapItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message =
      createBaseStcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap_StcsCompAccDataMetaDataAccIdMapItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.acc_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.acc_name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap_StcsCompAccDataMetaDataAccIdMapItem {
    return {
      acc_id: isSet(object.acc_id) ? globalThis.String(object.acc_id) : "",
      acc_name: isSet(object.acc_name) ? globalThis.String(object.acc_name) : "",
    };
  },

  toJSON(
    message: StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap_StcsCompAccDataMetaDataAccIdMapItem,
  ): unknown {
    const obj: any = {};
    if (message.acc_id !== "") {
      obj.acc_id = message.acc_id;
    }
    if (message.acc_name !== "") {
      obj.acc_name = message.acc_name;
    }
    return obj;
  },

  create<
    I extends Exact<
      DeepPartial<StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap_StcsCompAccDataMetaDataAccIdMapItem>,
      I
    >,
  >(base?: I): StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap_StcsCompAccDataMetaDataAccIdMapItem {
    return StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap_StcsCompAccDataMetaDataAccIdMapItem.fromPartial(
      base ?? ({} as any),
    );
  },
  fromPartial<
    I extends Exact<
      DeepPartial<StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap_StcsCompAccDataMetaDataAccIdMapItem>,
      I
    >,
  >(object: I): StcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap_StcsCompAccDataMetaDataAccIdMapItem {
    const message =
      createBaseStcsCompAccDataMetaData_StcsCompAccDataMetaDataAccIdMap_StcsCompAccDataMetaDataAccIdMapItem();
    message.acc_id = object.acc_id ?? "";
    message.acc_name = object.acc_name ?? "";
    return message;
  },
};

function createBaseStcsCompAccDataValues(): StcsCompAccDataValues {
  return { pnl_map: {}, bs_map: {} };
}

export const StcsCompAccDataValues: MessageFns<StcsCompAccDataValues> = {
  encode(message: StcsCompAccDataValues, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    Object.entries(message.pnl_map).forEach(([key, value]) => {
      StcsCompAccDataValues_PnlMapEntry.encode({ key: key as any, value }, writer.uint32(34).fork()).join();
    });
    Object.entries(message.bs_map).forEach(([key, value]) => {
      StcsCompAccDataValues_BsMapEntry.encode({ key: key as any, value }, writer.uint32(42).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompAccDataValues {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompAccDataValues();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = StcsCompAccDataValues_PnlMapEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.pnl_map[entry4.key] = entry4.value;
          }
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          const entry5 = StcsCompAccDataValues_BsMapEntry.decode(reader, reader.uint32());
          if (entry5.value !== undefined) {
            message.bs_map[entry5.key] = entry5.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompAccDataValues {
    return {
      pnl_map: isObject(object.pnl_map)
        ? Object.entries(object.pnl_map).reduce<{ [key: string]: StcsCompAccDataValuesMap }>((acc, [key, value]) => {
          acc[key] = StcsCompAccDataValuesMap.fromJSON(value);
          return acc;
        }, {})
        : {},
      bs_map: isObject(object.bs_map)
        ? Object.entries(object.bs_map).reduce<{ [key: string]: StcsCompAccDataValuesMap }>((acc, [key, value]) => {
          acc[key] = StcsCompAccDataValuesMap.fromJSON(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: StcsCompAccDataValues): unknown {
    const obj: any = {};
    if (message.pnl_map) {
      const entries = Object.entries(message.pnl_map);
      if (entries.length > 0) {
        obj.pnl_map = {};
        entries.forEach(([k, v]) => {
          obj.pnl_map[k] = StcsCompAccDataValuesMap.toJSON(v);
        });
      }
    }
    if (message.bs_map) {
      const entries = Object.entries(message.bs_map);
      if (entries.length > 0) {
        obj.bs_map = {};
        entries.forEach(([k, v]) => {
          obj.bs_map[k] = StcsCompAccDataValuesMap.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompAccDataValues>, I>>(base?: I): StcsCompAccDataValues {
    return StcsCompAccDataValues.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompAccDataValues>, I>>(object: I): StcsCompAccDataValues {
    const message = createBaseStcsCompAccDataValues();
    message.pnl_map = Object.entries(object.pnl_map ?? {}).reduce<{ [key: string]: StcsCompAccDataValuesMap }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsCompAccDataValuesMap.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.bs_map = Object.entries(object.bs_map ?? {}).reduce<{ [key: string]: StcsCompAccDataValuesMap }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsCompAccDataValuesMap.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseStcsCompAccDataValues_PnlMapEntry(): StcsCompAccDataValues_PnlMapEntry {
  return { key: "", value: undefined };
}

export const StcsCompAccDataValues_PnlMapEntry: MessageFns<StcsCompAccDataValues_PnlMapEntry> = {
  encode(message: StcsCompAccDataValues_PnlMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsCompAccDataValuesMap.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompAccDataValues_PnlMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompAccDataValues_PnlMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsCompAccDataValuesMap.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompAccDataValues_PnlMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsCompAccDataValuesMap.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsCompAccDataValues_PnlMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsCompAccDataValuesMap.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompAccDataValues_PnlMapEntry>, I>>(
    base?: I,
  ): StcsCompAccDataValues_PnlMapEntry {
    return StcsCompAccDataValues_PnlMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompAccDataValues_PnlMapEntry>, I>>(
    object: I,
  ): StcsCompAccDataValues_PnlMapEntry {
    const message = createBaseStcsCompAccDataValues_PnlMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsCompAccDataValuesMap.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompAccDataValues_BsMapEntry(): StcsCompAccDataValues_BsMapEntry {
  return { key: "", value: undefined };
}

export const StcsCompAccDataValues_BsMapEntry: MessageFns<StcsCompAccDataValues_BsMapEntry> = {
  encode(message: StcsCompAccDataValues_BsMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsCompAccDataValuesMap.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompAccDataValues_BsMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompAccDataValues_BsMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsCompAccDataValuesMap.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompAccDataValues_BsMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsCompAccDataValuesMap.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsCompAccDataValues_BsMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsCompAccDataValuesMap.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompAccDataValues_BsMapEntry>, I>>(
    base?: I,
  ): StcsCompAccDataValues_BsMapEntry {
    return StcsCompAccDataValues_BsMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompAccDataValues_BsMapEntry>, I>>(
    object: I,
  ): StcsCompAccDataValues_BsMapEntry {
    const message = createBaseStcsCompAccDataValues_BsMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsCompAccDataValuesMap.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompAccDataValuesMap(): StcsCompAccDataValuesMap {
  return { values_map: {} };
}

export const StcsCompAccDataValuesMap: MessageFns<StcsCompAccDataValuesMap> = {
  encode(message: StcsCompAccDataValuesMap, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    Object.entries(message.values_map).forEach(([key, value]) => {
      StcsCompAccDataValuesMap_ValuesMapEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompAccDataValuesMap {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompAccDataValuesMap();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = StcsCompAccDataValuesMap_ValuesMapEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.values_map[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompAccDataValuesMap {
    return {
      values_map: isObject(object.values_map)
        ? Object.entries(object.values_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: StcsCompAccDataValuesMap): unknown {
    const obj: any = {};
    if (message.values_map) {
      const entries = Object.entries(message.values_map);
      if (entries.length > 0) {
        obj.values_map = {};
        entries.forEach(([k, v]) => {
          obj.values_map[k] = v;
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompAccDataValuesMap>, I>>(base?: I): StcsCompAccDataValuesMap {
    return StcsCompAccDataValuesMap.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompAccDataValuesMap>, I>>(object: I): StcsCompAccDataValuesMap {
    const message = createBaseStcsCompAccDataValuesMap();
    message.values_map = Object.entries(object.values_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseStcsCompAccDataValuesMap_ValuesMapEntry(): StcsCompAccDataValuesMap_ValuesMapEntry {
  return { key: "", value: 0 };
}

export const StcsCompAccDataValuesMap_ValuesMapEntry: MessageFns<StcsCompAccDataValuesMap_ValuesMapEntry> = {
  encode(message: StcsCompAccDataValuesMap_ValuesMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompAccDataValuesMap_ValuesMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompAccDataValuesMap_ValuesMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompAccDataValuesMap_ValuesMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: StcsCompAccDataValuesMap_ValuesMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompAccDataValuesMap_ValuesMapEntry>, I>>(
    base?: I,
  ): StcsCompAccDataValuesMap_ValuesMapEntry {
    return StcsCompAccDataValuesMap_ValuesMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompAccDataValuesMap_ValuesMapEntry>, I>>(
    object: I,
  ): StcsCompAccDataValuesMap_ValuesMapEntry {
    const message = createBaseStcsCompAccDataValuesMap_ValuesMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
